import { render, staticRenderFns } from "./SettingsTemplateLayout.vue?vue&type=template&id=99d6f6a8&"
import script from "./SettingsTemplateLayout.vue?vue&type=script&lang=js&"
export * from "./SettingsTemplateLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports